import { ActionContext, LoginContext } from '@/utils/interfaces'
import {
  localStorageConfigsName
} from '@/utils/types'

const savedConfigs = () => {
  const __CASHIER_DEMO_CONFIGS__: string | null = localStorage.getItem(localStorageConfigsName)
  const configs = __CASHIER_DEMO_CONFIGS__ && JSON.parse(__CASHIER_DEMO_CONFIGS__)
  return configs && configs.demoThemesOptions && configs.demoThemesOptions.theme || 'PIQGreen'
}

export default {
  state: {
    latestConfigs: {
      css: '',
      config: {}
    },
    depositMessage: '',
    logInSuccessMsg: false,
    firstDeposit: false,
    accountType: 'account',
    quickDeposit: false,
    isAuthenticated: false,
    credentials: {
      username: null,
      email: null
    },
    sidebar: false,
    logInModal: false,
    loginMethod: '',
    loginMethods: [
      {
        label: 'Email',
        providerName: 'email'
      },
      {
        label: 'BankId',
        providerName: 'gii-bankid-se'
      },
      {
        label: 'Freja',
        providerName: 'gii-freja'
      },
      {
        label: 'Yoti',
        providerName: 'gii-yoti'
      },
      {
        label: 'NemId',
        providerName: 'gii-nemid'
      },
      {
        label: 'Smart-ID',
        providerName: 'gii-smartid'
      },
      {
        label: 'EU-teller',
        providerName: 'gii-eutellerid'
      },
      {
        label: 'Sum&Sub',
        providerName: 'gii-sumsub'
      },
      {
        label: 'Veriff',
        providerName: 'gii-veriff'
      },
      {
        label: 'E-idas',
        providerName: 'gii-eidas'
      },
      {
        label: 'Trustly',
        providerName: 'trustly'
      },
      {
        label: 'Zimpler',
        providerName: 'zimpler'
      },
      {
        label: 'Paypal',
        providerName: 'paypal'
      }
    ],
    userBalance: {
      bonus: 1000,
      balance: 1000,
      pendingWithdrawals: 0
    },
    multipleEventlistenersCheck: false,
    choosedTheme: savedConfigs(),
    themeOptions: [
      'PIQGreen',
      'yellow',
      'royalGreen',
      'LightBlue',
      // 'frost',
      // 'dark',
      // 'blue',
      'red',
      // 'green',
      'darkgrey',
      // 'blackRed'
    ],
    currencyCode: '',
    pageLayoutOptions: [
      'layout1',
      'layout2',
      'layout3',
      'layout4'
    ],
    pageLayout: 'layout2', // The initial value here will be the default value.
    drawerMiniVariant: false
  },
  mutations: {
    setLatestCss (state: any, css: string) {
      state.latestConfigs.css = css
    },
    setLatestConfig (state: any, config: object) {
      state.latestConfigs.config = config
    },
    setDrawerMiniVariant (state: any, payload: boolean) {
      state.drawerMiniVariant = payload
    },
    setLogInSuccessMsg (state: any, payload: boolean) {
      state.logInSuccessMsg = payload
    },
    setPageLayout (state: any, payload: string) {
      state.pageLayout = payload
    },
    setPageTheme (state: any, payload: string) {
      state.choosedTheme = payload
    },
    setAccountType (state: any, payload: string) {
      state.accountType = payload
    },
    setSidebar (state: any, payload: boolean) {
      state.sidebar = payload
    },
    setLogInModal (state: any, payload: any) {
      let newVal = payload
      if (payload === undefined) {
        newVal = !state.logInModal
      }
      state.logInModal = newVal
    },
    setLoginMethod (state: any, method: string) {
      state.loginMethod = method
    },
    setUsername (state: any, payload: string) {
      state.credentials.username = payload
    },
    setEmail (state: any, payload: string) {
      state.credentials.email = payload
    },
    isAuthenticated (state: any, payload: boolean) {
      state.isAuthenticated = payload
    },
    setUserBalance (state: any, payload: object) {
      state.userBalance = payload
    },
    setBalance (state: any, amount: number) {
      state.userBalance.balance = amount
    },
    setBonus (state: any, amount: number) {
      state.userBalance.bonus = amount
    },
    setPendingAmount (state: any, amount: number) {
      state.userBalance.pendingWithdrawals = amount
    },
    multipleEventlistenersCheck (state: any, boo: boolean) {
      state.multipleEventlistenersCheck = boo
    },
    setFirstDeposit (state: any, boo: boolean) {
      state.firstDeposit = boo
    },
    setDepositMessage (state: any, text: string) {
      state.depositMessage = text
    },
    setCurrencyCode (state: any, currency: string) {
      state.currencyCode = currency
    },
    setQuickDeposit (state: any, payload: boolean) {
      state.quickDeposit = payload
    }
  },
  actions: {
    async setCurrency ({ commit, rootState }: ActionContext) {
      const { merchantId = 1000, userId = 123, locale = null, sessionId = 123 } = rootState.cashierContext.config
      const cashierReq = await fetch(`https://test-api.paymentiq.io/cashier/${merchantId}/${userId}?locale=${locale}&method=deposit&sessionId=${sessionId}`)
      const transactionsReq = await fetch(`https://test-api.paymentiq.io/user/transaction/${merchantId}/${userId}?sessionId=${sessionId}`)
      const { transactions } = await transactionsReq.json()
      const waitingApprovalArr = transactions.filter((val: any) => val.state === 'WAITING_APPROVAL')
      let totalWaitingAppAmount = 0
      waitingApprovalArr && waitingApprovalArr.forEach((val: any) => {
        totalWaitingAppAmount += Number(val.amount.split('.')[0].replace('-', ''))
      })
      commit('setPendingAmount', totalWaitingAppAmount)
      const { data } = await cashierReq.json()
      const currency = data[0].userInfo.currencyCode
      console.log(currency)
      switch (currency) {
        case 'SEK':
          commit('setCurrencyCode', 'SEK ')
          break
        case 'GBP':
          commit('setCurrencyCode', '£')
          break
        case 'USD':
          commit('setCurrencyCode', '$')
          break
        case 'EUR':
          commit('setCurrencyCode', '€')
          break
        default:
          commit('setCurrencyCode', currency + ' ')
          break
      }
    },
    setSidebar ({ commit, state }: ActionContext, payload: boolean) {
      const oppositeBoolean = !state.sidebar
      commit('setSidebar', oppositeBoolean)
    },
    setPageTheme ({ commit, dispatch }: ActionContext, payload: string) {
      commit('setPageTheme', payload)
      dispatch('setUserInfo')
    },
    depositAmount ({ state, commit, dispatch }: ActionContext, payload: number | string | [number, string]): void {
      let bonusAmount = 0
      const amount = typeof payload === 'object' ? payload[0] : payload
      if (!state.firstDeposit && typeof payload === 'object' && !state.quickDeposit) {
        bonusAmount = Number(amount)
        commit('setFirstDeposit', true)
        commit('setDepositMessage', `Congratulations! You've just recieved ${state.currencyCode}${bonusAmount} in bonus!`)
      } else if (state.quickDeposit) {
        bonusAmount = 200
      }
      if (!state.multipleEventlistenersCheck) {
        const newAmount: number = (Number(state.userBalance.balance) + (Number(amount) + bonusAmount))
        commit('setBalance', newAmount)
        dispatch('setUserInfo')
        if (bonusAmount) {
          commit('setBonus', (state.userBalance.bonus + bonusAmount))
        }
      }
      commit('multipleEventlistenersCheck', true)
      setTimeout(() => {
        commit('multipleEventlistenersCheck', false)
      }, 1500)
    },
    subtractAmount ({ state, commit, dispatch }: ActionContext, amount: number): void {
      if (!state.multipleEventlistenersCheck) {
        const newAmount: number = (Number(state.userBalance.balance) - Number(amount))
        const newBonus: number = (Number(state.userBalance.bonus) - Number(amount))
        if (newAmount > 0) {
          commit('setBalance', newAmount)
        } else {
          commit('setBalance', 0)
        }
        if (newBonus > 0) {
          commit('setBonus', newBonus)
        } else {
          commit('setBonus', 0)
        }
        dispatch('setUserInfo')
      }
      commit('multipleEventlistenersCheck', true)
      setTimeout(() => {
        commit('multipleEventlistenersCheck', false)
      }, 1500)
    },
    setUserInfo ({ state, commit }: ActionContext, payload: LoginContext): void {
      const sessionObj = {
        isAuth: (payload && payload.isAuth) || state.isAuthenticated,
        credentials: {
          ...state.credentials,
          ...payload && payload
        },
        userBalance: {
          ...state.userBalance
        },
        pageTheme: state.choosedTheme,
        firstDeposit: state.firstDeposit
      }
      sessionStorage.setItem('__CASHIER_DEMO_SESSION__', JSON.stringify(sessionObj))
    },
    setSessionUser ({ commit }: ActionContext, payload: any = {}) {
      commit('isAuthenticated', payload.isAuth)
      commit('setEmail', payload.credentials.email)
      commit('setUsername', payload.credentials.username)
      commit('setUserBalance', payload.userBalance)
      commit('setPageTheme', payload.pageTheme)
      commit('setFirstDeposit', payload.firstDeposit)
    },
    loginUser ({ commit, dispatch }: ActionContext, payload: LoginContext) {
      const fixedUserName = payload.username.split(' ')
        .map((val: string) => val[0].toUpperCase() + val.substr(1).toLowerCase()).join(' ')
      payload.username = fixedUserName
      commit('isAuthenticated', payload.isAuth)
      commit('setUsername', payload.username)
      commit('setEmail', payload.email)
      dispatch('setUserInfo', payload)
      commit('setLogInModal', false)
      commit('setLogInSuccessMsg', true)
    },
    loginUserPassword ({ state, commit, dispatch }: ActionContext) {
      const userInfo = {
        isAuth: true,
        email: state.credentials.email,
        username: state.credentials.username
      }
      dispatch('loginUser', userInfo)
    },
    logout ({ commit }: ActionContext) {
      sessionStorage.removeItem('__CASHIER_DEMO_SESSION__')
      commit('isAuthenticated', false)
      commit('setEmail', '')
      commit('setUsername', '')
      commit('setFirstDeposit', false)
      window.location.reload()
    }
  }
}
